import { type TFunction } from 'next-i18next'

type FooterLink = {
  href?: string
  label: string
  tooltipContent?: string
  type: 'link'
}

type LanguageToggle = {
  locale: string
  label: string
  type: 'languageToggle'
}

type FooterLinks = {
  title: string
  links: (FooterLink | LanguageToggle)[]
}

//It doesn't look like we're using the tooltip content here
/**
 * @param t - Translate function from next-translate. Should be using global_footer translations
 * @returns list of footer links separated by groups of links
 */
export const FOOTER_LINKS = (t: TFunction): FooterLinks[] => [
  {
    title: t('global_footer:links.kijiji.title'),
    links: [
      {
        type: 'link',
        label: t('global_footer:links.kijiji.about.label'),
        href: `${t('routes:external.about.href')}`,
      },
      {
        type: 'link',
        label: t('global_footer:links.kijiji.join_us.label'),
        href: `${t('routes:external.join_us.href')}`,
      },
      {
        type: 'link',
        label: t('global_footer:links.kijiji.member_benefits.label'),
        href: `${t('routes:external.member_benefits.href')}`,
      },
      {
        type: 'link',
        label: t('global_footer:links.kijiji.advertise.label'),
        href: `${t('routes:external.advertise.href')}`,
      },
    ],
  },
  {
    title: t('global_footer:links.explore.title'),
    links: [
      {
        type: 'link',
        label: t('global_footer:links.explore.kijiji_performance.label'),
        href: `${t('routes:external.performance.href')}`,
      },
    ],
  },
  {
    title: t('global_footer:links.info.title'),
    links: [
      {
        type: 'link',
        label: t('global_footer:links.info.terms_of_use.label'),
        href: `${t('routes:external.terms_of_use.href')}`,
      },
      {
        type: 'link',
        label: t('global_footer:links.info.privacy_policy.label'),
        href: `${t('routes:external.privacy_policy.href')}`,
      },
      {
        type: 'link',
        label: t('global_footer:links.info.posting_policy.label'),
        href: `${t('routes:external.posting_policy.href')}`,
      },
      {
        type: 'link',
        label: t('common:ad_choices.label'),
        href: `${t('routes:external.ad_choices.href')}`,
        tooltipContent: `${t('global_footer:links.info.ad_choices.tooltip_content')}`,
      },
    ],
  },
  {
    title: t('global_footer:links.support.title'),
    links: [
      {
        type: 'link',
        label: t('global_footer:links.support.help_desk.label'),
        href: `${t('routes:external.help_desk.href')}`,
      },
      {
        type: 'languageToggle',
        label: t('common:language_toggle.text.long'),
        locale: `${t('global_footer:language_toggle.locale')}`,
      },
      {
        type: 'link',
        label: t('global_footer:links.support.accessibility.label'),
        href: `${t('routes:external.accessibility.href')}`,
      },
    ],
  },
]
